import { ErrorLogComponent } from '@cian/error-log-component';
import { useDeviceType } from '@cian/ui-kit';
import loadable from '@loadable/component';
import Cookies from 'js-cookie';
import * as React from 'react';

import { useIsOnboardingEnabled } from './useIsOnboardingEnabled';
import { ONBOARDING_FIRST_VISIT_COOKIE_NAME } from '../../constants/cookies';
import { useApplicationContext } from '../../utils/applicationContext';

const OnboardingContainerLoadable = loadable(() => import('./OnboardingContainerLoadable'), {
  resolveComponent: module => module.OnboardingContainer,
});

export function OnboardingContainer() {
  const ctx = useApplicationContext();
  const isEnabled = useIsOnboardingEnabled();
  const isMobile = useDeviceType() === 'phone';

  React.useMemo(() => {
    if (!isMobile) {
      return;
    }
    if (Cookies.get(ONBOARDING_FIRST_VISIT_COOKIE_NAME) != null) {
      return;
    }
    Cookies.set(ONBOARDING_FIRST_VISIT_COOKIE_NAME, String(Date.now()), {
      domain: '.cian.ru',
      expires: 365,
    });
  }, [isMobile]);

  if (!isEnabled) {
    return null;
  }

  return (
    <ErrorLogComponent logger={ctx.logger}>
      <OnboardingContainerLoadable />
    </ErrorLogComponent>
  );
}
